<template>
  <div class="t9_project_default wrapper">
    <div class="header-layer">
      <div class="city" @click="clickCity()">{{cityname}}</div>
      <div class="search-layer">
        <input
          ref="input"
          type="search"
          placeholder="输入楼盘名称"
          v-model="keyword"
          class="info-input"
          @blur="blurInput"
          @input="query()"
        />
      </div>
      <img
        @click="clickDiTuZhaoFang"
        src="https://assets.rurushishi.com/yq-rs-make/huafa/map.png"
        alt
      />
    </div>
    <div class="line"></div>
    <!--     <div class="content" ref="contentLayer" :style="{height: contentH + 'px'}"> -->
    <div class="content" ref="contentLayer">
      <!--发布list-->
      <div class="common-nodata-item" v-if="noData">暂无数据</div>
      <mt-loadmore :bottom-method="loadMore" :bottom-all-loaded="!hasMore" ref="loadmore">
        <projectList :list="list"></projectList>
      </mt-loadmore>
      <div class="common-nodata-item" v-if="allLoad">已加载全部数据</div>
    </div>
    <!-- <Tabbar7></Tabbar7> -->

    <CityCheck
      :hotlist="hotlist"
      :areaslist="areaslist"
      :cityname="cityname"
      :isShow="isShowCheck"
      :showAll="true"
      v-on:close="closeCityCheck"
      v-on:choose="chooseCityCheck"
    ></CityCheck>

    <BtnBackLayout4></BtnBackLayout4>

  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { Loadmore } from "mint-ui"; //上拉刷新
import { mapState, mapMutations } from "vuex";
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
import Vue from "vue";
Vue.component(Loadmore.name, Loadmore);

const Tabbar7 = () => import("@/components/tabbar7");
const projectList = () => import("@/components/project_list");
const CityCheck = () => import("@/components/city_check2");
export default {
  components: {
    BtnBackLayout4,
    CityCheck,
    projectList,
    Tabbar7
  },
  data() {
    return {
      showSelect: false,
      keyword: "",
      citys: [
        {
          name: "不限",
          pageid: -1,
          active: true
        }
      ],
      curCity: "",
      curIdx: 0,
      cityname: "全部",
      //新组件
      isShowCheck: false,
      hotlist: [],
      areaslist: [],
      //列表
      noData: false,
      allLoad: false,
      hasMore: true,
      loading: true,
      pageIndex: 1,
      offset: 0,
      pageSize: 20,
      contentH: 0,
      list: []
    };
  },
  computed: {
    ...mapState(["pageInfo", "isInMiniProgram", "shareSpreadInfo"])
  },
  watch: {},
  filters: {},
  methods: {
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      this.temporaryRepair();
    },
    // lj07
    clickDiTuZhaoFang() {
      let url = `${location.protocol}//${location.host}/h5/t9_map?from=t9`;
      util.openYqRsMakeLink(url);
    },
    query() {
      let that = this;
      clearTimeout(that.timer);
      that.timer = setTimeout(function() {
        // that.list = [];
        that.pageIndex = 1;
        that.offset = 0;
        that.pageSize = 20;
        that.hasMore = true;
        that.loading = true;
        that.noData = false;
        that.allLoad = false;
        that.loadData("search");
      }, 500);
    },
    loadMore() {
      const that = this;
      if (that.hasMore && !that.loading) {
        that.pageIndex++;
        that.loadData();
      }
    },
    loadData(type) {
      let that = this;
      that.loading = true;
      let offset = that.pageIndex * that.pageSize - that.pageSize;
      let size = that.pageSize;
      util.checkMapStateCallback(that, ["pageInfo"]).then(() => {
        comreq
          .listPageByPageExtTags(
            that.curCity,
            that.keyword,
            offset,
            size,
            this.pageInfo.PageId
          )
          .then(data => {
            if (data.obj.total == 0) {
              that.list = [];
              that.noData = true;
            } else {
              that.$refs.loadmore.onBottomLoaded();
              that.noData = false;
              that.loading = false;
              let list = [];
              data.obj.list.forEach(e => {
                if (e.extinfo) {
                  e.extinfo = JSON.parse(e.extinfo);
                  if (e.extinfo.advantage) {
                    e.extinfo.advantage = e.extinfo.advantage.split(",");
                  }
                }
                this.areaslist.forEach(item => {
                  item.list.forEach(item2 => {
                    if(item2.minipid === e.miniproj && e.miniproj) {
                      e.click_url += `&t9id=${item2.pageid}&t9psn=${item2.psn}`
                    }
                  })
                })
                list.push(e);
              });
              // 比较上当前的列表一样吗
              if (type == "search") {
                if (util.arrSame(that.list, list)) {
                  console.log("查询列表一样，不做dom操作");
                } else {
                  that.list = [];
                  that.list = that.list.concat(list);
                }
              } else {
                that.list = that.list.concat(list);
              }

              if (data.obj.total <= that.list.length) {
                that.hasMore = false;
                that.allLoad = true;
              }
              if (that.pageIndex == 1) {
                that.$nextTick(() => {
                  that.$refs.contentLayer.scrollTop = 0;
                });
              }
            }
            console.log("项目数据", data.obj);
          });
      });
    },
    setCurCity() {
      let tmp = [];
      if (this.cityname == "全部") {
        this.citys.forEach(e => {
          if (e.pageid != -1) {
            tmp.push(e.pageid);
          }
        });
      } else {
        this.citys.forEach(e => {
          if (e.name == this.cityname) {
            tmp.push(e.pageid);
          }
        });
      }
      this.curCity = tmp.join(",");
    },

    checkItem(item) {
      if (item.active == true) {
        return;
      } else {
        let tmp = [];
        this.citys.forEach((e, idx) => {
          e.active = false;
          if (e.pageid == item.pageid) {
            e.active = true;
            if (e.pageid == -1) {
              this.cityname = "全部";
            } else {
              this.cityname = e.name;
            }
            this.curIdx = idx;
          }
          tmp.push(e);
        });
        this.citys = tmp;
        this.setCurCity();
        this.query();
      }
      this.showSelect = false;
    },
    clickCity() {
      this.isShowCheck = true;
      // this.showSelect = true;
    },
    hideScrim() {
      this.showSelect = false;
    },
    handleScroll() {
      console.log;
    },
    closeCityCheck() {
      this.isShowCheck = false;
    },
    chooseCityCheck(cityname) {
      this.isShowCheck = false;
      this.cityname = cityname;
      this.setCurCity();
      this.query();
    },
    thisFocus(){
      this.$refs.input.focus()
    }

  },
  mounted() {
    let that = this;

    //获取当前城市
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      //获取配置的城市
      comreq.guideConfig(this.pageInfo.Extinfo.guideConfigId).then(data => {
        let jsonObj = JSON.parse(data.obj.data);
        console.log(jsonObj)
        this.hotlist = jsonObj.hots;
        this.areaslist = jsonObj.areas;
        let tmp = [];
        jsonObj.areas.forEach(item => {
          item.list.forEach(e => {
            if (e.url && e.url != "##" && e.url != "####") {
              tmp.push({
                name: e.name,
                active: false,
                pageid: e.pageid
              });
            }
          });
        });
        that.citys = that.citys.concat(tmp);
        that.setCurCity();
        that.loadData();
      });
    });

    that.thisFocus();
    setTimeout(() => {
      that.thisFocus()
    }, 0);

    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="stylus" scoped>
.wrapper {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  background-color: #ffffff;
}

.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 1.1rem;
  bottom: 0;
  overflow: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

.line {
  width: 100%;
  height: 5px;
  background-color: #f5f5f5;
}

.content ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  // padding: 0 0.6rem
}

.item {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
  position: relative;
}

.item > img {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.8rem;
  display: block;
}

.item .username {
  flex: 1;
  text-align: right;
}

.common-nodata-item {
  line-height: 0.8rem;
  font-size: 0.24rem;
  color: #212121;
  text-align: center;
}

.header-layer {
  line-height: 1rem;
  padding: 0 0.28rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-layer .city {
  font-size: 0.3rem;
  font-weight: bold;
  color: #cf0000;
  background: url('https://assets.rurushishi.com/yq-rs-make/huafa/drop.png') no-repeat right center;
  background-size: 0.18rem 0.18rem;
  padding-right: 0.25rem;
}

.header-layer .search-layer {
  flex: 1;
  margin: 0 0.16rem;
  border-radius: 4px;
  background: #f4f4f4 url('https://assets.rurushishi.com/yq-rs-make/huafa/sousuo.png') no-repeat left 5px center;
  background-size: 0.24rem 0.24rem;
  height: 0.62rem;
  line-height: 0.62rem;
}

.header-layer .search-layer > input {
  width: 100%;
  padding-left: 0.4rem;
  font-size: 0.24rem;
  color: #666666;
  height: 0.62rem;
  background: transparent;
  line-height: 0.62rem;
}

.header-layer > img {
  width: 1.89rem;
  height: 0.6rem;
  display: block;
}

.scrim-layer {
  position: fixed;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 999;
}

.drop-layer {
  position: absolute;
  top: 1rem;
  width: 100%;
  max-height: 4rem;
  overflow: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  background-color: #ffffff;
  z-index: 999;
}

.drop-layer.animation {
  animation: fadeInDown 0.5s;
}

.drop-layer .drop-item {
  line-height: 0.88rem;
  padding-left: 0.24rem;
}

.drop-layer .drop-item.selected {
  background: url('https://assets.rurushishi.com/yq-rs-make/huafa/selected.png') no-repeat right 0.2rem center;
  background-size: 0.5rem 0.5rem;
  color: #ffa45b;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
</style>